import { render, staticRenderFns } from "./ConfirmacionPresupuesto.vue?vue&type=template&id=fd96ec8a&scoped=true"
import script from "./ConfirmacionPresupuesto.vue?vue&type=script&lang=js"
export * from "./ConfirmacionPresupuesto.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacionPresupuesto.vue?vue&type=style&index=0&id=fd96ec8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd96ec8a",
  null
  
)

export default component.exports